<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />
    <ProgramInfo id="program" :info="programData" />
    <BasicRequirement :info="basicRequirement" />
    <PositionSummary :info="positionInfo" />
    <TestimonialCompany :info="companyTestimonial" style="padding-top:40px" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>
<script>
import AboutInstructor from '../../../components/AssessmentIsa/AboutTheCompany.vue'
import TestimonialCompany from '../../../components/AssessmentIsa/CompanyTestimonial.vue'
import Landing from '../../../components/AssessmentIsa/LandingAssessment.vue'
import ProgramInfo from '../../../components/AssessmentIsa/ProgramInfo.vue'
import Contact from '../../../components/isaMain/Contact.vue'
import PositionSummary from '../../../components/AssessmentIsa/PositionSummary.vue'
import BasicRequirement from '../../../components/AssessmentIsa/BasicReq.vue'
import Faq from '../../../components/shera/Faq.vue'

export default {
  data() {
    return {
      landingData: {
        title1: 'Work at AFC as a Red Hat Certified Administrator',
        //   subTitle: 'Senior Marketing Executive (Contractual)',
        paragraph:
          'Become a Red Hat Certified Administrator with a salary of BDT 40,000 to 60,000. Take the assessment curated by Upskill to apply! ',
        companyLogo: '',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/35262fda-8f93-4499-8810-86c34c8589ad?public=true&job=aventraRedhat',
        landingImage: require('../../../assets/bongo/18775.png'),
        spanColor: 'grey',
      },
      instructorData: {
        //   name: 'Fayaz Taher',
        avatar: require('../../../assets/bongo/rsz_image1-removebg-preview.png'),
        info:
          'Aventra Financial Consultant is a complete data Analysis & Software Solution Company. Founded In 2021. They help businesses automate their business process and data analysis for their future business growth. Their experts help find and understand datas and research on the way people use data to solve their problems.',
        designation: '',

        bgColor: '#DDEAFA',
        txtColor: '#29292B',
      },
      programData: {
        headingInfo:
          'Red Hat Certified Administrator Assessment consists of approximately 15 MCQs. You are required to pass the assessment test with a minimum of 60% of the total score.Top 5-10 Candidates will get the chance to go to the interview round after completing the assessment. So, don’t miss this opportunity as the time is limited!',
        startDate: 'March 1, 2022',
        cost: 'Free',
        deadline: 'March 8, 2022',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        bgColor: '#1EBCE5',
        txtColor: '#5277F7',
      },
      positionInfo: {
        //   paragraph:
        //     'This role is within the department Bongo Studios (www.bongostudios.com), which is the fastest-growing vertical within Bongo. Bongo Studios is a Multi-Channel Network (MCN) of a community of creative and independent content producers from multiple countries. We nurture talent and optimize content for our creators to help them achieve enhanced growth and monetization on multiple platforms (YouTube, Facebook, BongoBD, etc.). Currently, our creators reach over 180 million subscribers and have over 1.5 billion views per month.For this job role, we are looking for someone who is PMP certified and hassuccessfully managed a large team for at least 3 years, at a well-recognized company.The ideal candidate will be responsible for planning, coordinating, and managing the team within the timeline, budget, scope, and targets set for the department. They will also effectively monitor and present the updates to relevant stakeholders, clients, and team members.',
        //   remote: '',
        //   jobType: 'Job Type: Full-time ',
        //   txtColor: '#5277F7',
      },
      companyTestimonial: {
        //   mainImg: require('../assets/bongo/CTO_Bongo_Shadid 1.png'),
        //   name: 'Shadid Haque',
        //   paragraph:
        //     'At Bongo we believe in human-centric designs because people ignore design that ignores people. We are very excited to team up with Upskill in our mission to recruit the very best talents from all walks of life. We welcome anyone who wants to solve problems that impact millions of users and be part of a team that is empowered to do so.',
        //   designation: 'CTO  of Bongo',
        //   imgBg: '#DDEAFA',
        //   invertedCommaBg: '',
        //   firstComma: require('../assets/Canadian Tech company/“.svg'),
        //   secondComma: require('../assets/Canadian Tech company/Group 22.svg'),
      },
      basicRequirement: {
        mainContent: [
          'Candidate have to be Red Hat Certified System Administrator (RHCSA®)',
          'A bachelor’s degree in information systems or computer science or related discipline alongwith a strong understanding of the Unix-based operating system.',
          'Proficiency in scripting in Shell and Rails.',
          'Conversant with Cisco switches and Netbackup and database knowledge',
        ],
        bgColor: '#184DBD',
      },

      outlineColor: {
        color: '#EA4424',
      },

      faq: [
        {
          title: 'What is the duration of the assessment? \n',
          content: '10 minutes. \n',
          category: 'FAQ',
        },
        {
          title: 'What is the assessment  fee? \n',
          content: 'It is free',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous work experience? \n',
          content:
            'Candidate have to be Red Hat Certified System Administrator (RHCSA®)n',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify?\n',
          content: '60% of the total score i.e. 9 out of 15',
          category: 'FAQ',
        },

        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.\n',
          category: 'FAQ',
        },
        {
          title: 'Will all the top 5 students get a job at Aventra?\n',
          content:
            'No, the top 5 students will get a chance to interview at Aventra, and will get the job depending on their performance in the interview.\n',
          category: 'FAQ',
        },
        {
          title: 'Salary?\n',
          content: ' BDT 40-60k \n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    Faq,
    ProgramInfo,
    Contact,
    TestimonialCompany,
    BasicRequirement,
    PositionSummary,
  },
  created() {
    this.Loaded()
  },
}
</script>
